import React from 'react';
import {motion} from 'framer-motion';
import RevenueWidget from './widgets/RevenueWidget';
import GrossMarginWidget from './widgets/GrossMarginWidget';
import PerformanceGraphWidget from './widgets/PerformanceGraphWidget';
import SalesTeamGMWidget from './widgets/SalesTeamGMWidget';
import SalesTeamPerformanceWidget from './widgets/SalesTeamPerformanceWidget';
import ClientCoordinatorsWidget from './widgets/ClientCoordinatorsWidget';
import BusinessLineWidget from './widgets/BusinessLineWidget';
import OffersWidget from './widgets/OffersWidget';
import MeetingStatusWidget from './widgets/MeetingStatusWidget';
import TaskManagementWidget from './widgets/TaskManagementWidget';

const Dashboard = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 100,
        damping: 15
      }
    }
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <motion.div
        className="mb-8"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="relative overflow-hidden glass rounded-2xl border border-white/20 shadow-xl p-8">
          <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 via-purple-500/10 to-pink-500/10"></div>
          <div className="absolute -top-4 -right-4 w-32 h-32 bg-gradient-to-br from-blue-400/20 to-purple-400/20 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-4 -left-4 w-40 h-40 bg-gradient-to-tr from-purple-400/10 to-pink-400/10 rounded-full blur-3xl"></div>
          
          <div className="relative">
            <motion.h1
              className="text-4xl font-bold gradient-text mb-4"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
            >
              Welcome to FuelDash
            </motion.h1>
            <motion.p
              className="text-lg text-gray-600 max-w-2xl"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
            >
              Your comprehensive business intelligence platform. Monitor performance, track goals, and drive growth with real-time insights.
            </motion.p>
          </div>
        </div>
      </motion.div>

      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="space-y-8"
      >
        {/* Top Row - Key Metrics (Now 2 columns instead of 3) */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <motion.div variants={itemVariants}>
            <RevenueWidget />
          </motion.div>
          <motion.div variants={itemVariants}>
            <GrossMarginWidget />
          </motion.div>
        </div>

        {/* Performance Graph */}
        <motion.div variants={itemVariants}>
          <PerformanceGraphWidget />
        </motion.div>

        {/* Sales Team Widgets */}
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
          <motion.div variants={itemVariants}>
            <SalesTeamGMWidget />
          </motion.div>
          <motion.div variants={itemVariants}>
            <SalesTeamPerformanceWidget />
          </motion.div>
        </div>

        {/* Client Coordinators and Business Lines */}
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
          <motion.div variants={itemVariants}>
            <ClientCoordinatorsWidget />
          </motion.div>
          <motion.div variants={itemVariants}>
            <BusinessLineWidget />
          </motion.div>
        </div>

        {/* Offers and Meetings */}
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
          <motion.div variants={itemVariants}>
            <OffersWidget />
          </motion.div>
          <motion.div variants={itemVariants}>
            <MeetingStatusWidget />
          </motion.div>
        </div>

        {/* Task Management */}
        <motion.div variants={itemVariants}>
          <TaskManagementWidget />
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Dashboard;